import Main from '@/components/main'
/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/home',
    component: Main,
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          title: '首页工作台',
          notCache: true,
          icon: 'md-home'
        },
        component: () => import('@/view/single-page/home')
      }
    ]
  },
  {
    path: '/report',
    name: 'report',
    meta: {
      icon: 'md-list',
      title: '报表管理'
    },
    component: Main,
    children: [
      {
        path: '/reportMain_page',
        name: 'reportMain_page',
        meta: {
          icon: 'md-list',
          title: '报表管理'
        },
        component: () => import('@/view/m-report/report-main.vue')
      }
    ]
  },
  {
    path: '/shopInfo',
    name: 'shopInfo',
    component: Main,
    children: [
      {
        path: '/shopMain_page',
        name: 'shopMain_page',
        meta: {
          icon: 'md-cash',
          title: '资产信息管理'
        },
        component: () => import('@/view/m-assets/shop-main.vue')
      }
    ]
  },
  {
    path: '/customerData',
    name: 'customerData',
    component: Main,
    children: [
      {
        path: '/customerData_page',
        name: 'customerData_page',
        meta: {
          icon: 'md-contact',
          title: '租户资料管理'
        },
        component: () => import('@/view/m-customer/customer-data.vue')
      }
    ]
  },
  {
    path: '/leaseContract',
    name: 'leaseContract',
    component: Main,
    children: [
      {
        path: '/leaseContract_page',
        name: 'leaseContract_page',
        meta: {
          icon: 'ios-paper',
          title: '租赁合同管理'
        },
        component: () => import('@/view/m-lease/lease-contract.vue')
      },
      {
        path: '/leaseAdd_page/:id',
        name: 'leaseAdd_page',
        meta: {
          icon: 'ios-paper',
          title: '新增合同'
        },
        component: () => import('@/view/m-lease/lease-add.vue')
      },
      {
        path: '/leaseDetail_page/:id',
        name: 'leaseDetail_page',
        meta: {
          icon: 'ios-paper',
          title: '合同详情'
        },
        component: () => import('@/view/m-lease/lease-detail.vue')
      }
    ]
  },
  {
    path: '/noticeWarn',
    name: 'noticeWarn',
    component: Main,
    children: [
      {
        path: '/noticeMain_page',
        name: 'noticeMain_page',
        meta: {
          icon: 'ios-warning',
          title: '通知预警'
        },
        component: () => import('@/view/m-notice/notice-main.vue')
      }
    ]
  },
  {
    path: '/costManage',
    name: 'costManage',
    component: Main,
    children: [
      {
        path: '/costMain_page',
        name: 'costMain_page',
        meta: {
          icon: 'logo-usd',
          title: '缴费管理'
        },
        component: () => import('@/view/m-cost/cost-main.vue')
      }
    ]
  },
  {
    path: '/systemInfo',
    name: 'systemInfo',
    component: Main,
    children: [
      {
        path: '/sysMain_page',
        name: 'sysMain_page',
        meta: {
          icon: 'ios-settings',
          title: '系统信息'
        },
        component: () => import('@/view/m-system/sys-main.vue')
      }
    ]
  },

  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  }
]
